import { Box, useMediaQuery } from '@mui/material';
import { PageOuterContainer } from '../../../root-components/layouts/page-outer-container'
import { SettingsMobileNavbar } from '../../../root-components/navigation/settings-mobile-navbar';
import { PageHeading } from '../../presentation-components/display-elements-components/page-heading';
import gaiaTheme from '../../../root-components/theme';
import { LoadingPage } from '../loading-page';
import { TableDisplay } from '../../presentation-components/miscellaneous-components/table-display';
import FileDownloadService from '../../../shared/services/file-download/file-download.service';
import { useContext, useEffect, useState } from 'react';
import { IHeadCell } from '../../../shared/interfaces/table-display.model';
import moment from 'moment';
import { TableActionButtons } from '../../presentation-components/miscellaneous-components/table-action-buttons';
import { IFileDownload } from '../../../shared/services/file-download/file-download.model';
import { UserNotificationsContext } from '../../../context/user-notifications/user-notifications';

export const SettingsDownloadFilesPage = () => {
  //Services
  const fileDownloadService = new FileDownloadService()
  //Context
  const userNotificationsContext = useContext(UserNotificationsContext)
  //State
  const [downloadedFiles, setDownloadedFiles] = useState<IFileDownload[]>([])
  //Table State
  const [inputPage, setInputPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0)
  const [perPage, setPerPage] = useState(10)
  const [selected, setSelected] = useState<string[]>([]);
  const [change, setChange] = useState<number>(0)
  const [orderBy, setOrderBy] = useState<string>()
  const [order, setOrder] = useState<'asc' | 'desc'>()
  //Loading State
  const [hasPageMounted, setHasPageMounted] = useState<boolean>(false)
  const [isLoading, setIsLoading] = useState<boolean>(true)
  //Layout
  const isMobileMode = useMediaQuery(gaiaTheme.breakpoints.down('md'));
  //Use Effects
  useEffect(() => {
      fileDownloadService.getAllWithPagination(null, 'all', inputPage, perPage, orderBy, order)
        .then(response => {
          setIsLoading(false)
          setTotalRecords(response.count)
          setDownloadedFiles(response.rows)
        })
        .catch(err => {
          setIsLoading(false)
          console.log(err)
        })
  }, [inputPage, perPage, change])

  useEffect(() => {
    if (hasPageMounted) {
      if (inputPage === 0) {
        setChange(change + 1)
      } else {
        setInputPage(0)
      }
    }
    setHasPageMounted(true)
  }, [order, orderBy])



  //Table Contents
  const headCells: IHeadCell[] = [
    { id: 'action', numeric: false, label: 'Action', sortable: false, includeInMobile: false },
    { id: 'fileName', numeric: false, label: 'File Name', sortable: true, isHeading: true },
    { id: 'mimeType', numeric: false, label: 'File Type', sortable: true, isHeading: true },
    { id: 'downloadDate', numeric: false, label: 'Created on', sortable: true, isHeading: true },
  ];

  const formatMimeType = (mimetype?: string | null): string => {
    if (!mimetype) return '—'
    if (mimetype === 'text/csv') return 'CSV'
    if (mimetype === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') return 'Excel'
    return mimetype
  }

  const rows = !downloadedFiles ? [] : downloadedFiles.filter(downloadedFile => downloadedFile.status === 'COMPLETED' || downloadedFile.status === null).map((downloadedFile) => {
    return {
      id: downloadedFile.id,
      fileName: downloadedFile.filename,
      mimeType: formatMimeType(downloadedFile.mimetype),
      downloadDate: moment(downloadedFile.downloadDate).format('DD/MM/YYYY HH:mm'),
      action:
        <TableActionButtons
          id={downloadedFile.id}
          includeDownload={true}
          onDownload={() => downloadHandler(downloadedFile.id)}
        />
    }
  })

  //Table Event Handlers
  const handleOrderChange = (orderBy: string, order: 'asc' | 'desc',) => {
    setOrderBy(orderBy)
    setOrder(order)
  };

  const downloadHandler = (downloadId: string) => {
    fileDownloadService.getOne(downloadId)
      .then(fileDownload => {
        return fileDownloadService.downloadFile(downloadId, fileDownload.filename)
      })
      .catch(err => {
        console.log(err)
        userNotificationsContext.openSnackbar({ open: true, message: 'There was an error, please try again', backgroundColor: 'text.primary' });
      })
  }


  return (
    <PageOuterContainer>
      {isMobileMode && <Box sx={{ pb: 4 }}>
        <SettingsMobileNavbar />
      </Box>}
      <PageHeading
        title='Downloaded Files'
        hasTabs={false}
      />
      <LoadingPage pageReady={!isLoading}>
        {downloadedFiles &&
          <TableDisplay
            onOrderChange={handleOrderChange}
            isMobileMode={isMobileMode}
            headCells={headCells}
            rows={rows}
            selected={selected}
            setSelected={setSelected}
            selectByIcon={true}
            inputPage={inputPage}
            setInputPage={setInputPage}
            totalRecords={totalRecords}
            perPage={perPage}
            setPerPage={setPerPage} />}
      </LoadingPage>
    </PageOuterContainer>
  )
}